import { DropdownOption } from "@components/library/Dropdowns/DropdownOption";
import api from "@requests/request";
import { universities_path } from "@routes/routes";
import { convertToSnakeCase } from "@utils/textUtils";
import { useEffect, useState } from "react";

function useUniversityOptions(): DropdownOption[] {
  const [universitiesOptions, setUniversitiesOptions] = useState<DropdownOption[]>([]);

  useEffect(() => {
    (async () => {
      const responseJson = await api.get<{ universities: { id: number; name: string }[] }>(
        universities_path()
      );

      const universities = (responseJson.data?.universities ?? []).map(
        (university: { id: number; name: string }) => ({
          key: convertToSnakeCase(university.name),
          text: university.name,
          value: String(university.id),
          label: university.name,
        })
      );

      setUniversitiesOptions(universities);
    })();
  }, []);

  return universitiesOptions;
}

export default useUniversityOptions;
